<template>
  <app-base-main
      no-padding
      parentTable
      :table-shadow="false">
    <template #filter-group>
      <app-filter-group
          @query="$gjNoticeQuery"
          @reset="$gjReset"
          :reset="false"
          :query="false">
        <gj-date-picker
            v-model="filter.date"
            type="daterange"
            tooltip="数据时间"
            :clearable="false"
            :max-day-length="180"
            @input="$gjNoticeQuery"
        ></gj-date-picker>
        <gj-radio-group
            v-model="filter.dateType"
            :options="dateTypeOptions"
            @input="$gjNoticeQuery"
        ></gj-radio-group>
      </app-filter-group>
    </template>
    <template #table>
      <gj-table
          ref="gjTable"
          adaptParent
          :index="false"
          name="asinAdTargetAnalysis"
          :data="tableData"
          :columns="columns"
          :loading="loading"
          border
          show-summary
          :summary-object="summaryData"
          @sort-change="$gjSortChange"
          @page-change="$gjNoticeQuery">
        <template v-slot:campaignTargetType="{row}">
          <template v-if="row.targetingType === 0">商品手动广告</template>
          <template v-else-if="row.targetingType === 1">商品自动广告</template>
          <template v-else-if="row.targetingType === 2">展示广告</template>
          <template v-else-if="row.targetingType === 3">
            <span style="color: #333; font-weight: bold">小计</span>
          </template>
          <template v-else-if="row.targetingType === 4">
            <span style="color: #333; font-weight: bold">合计</span>
          </template>
        </template>
      </gj-table>
    </template>
  </app-base-main>
</template>

<script>
  import {adFields} from "../../../common/fields";
  import {queryMixin} from "../../../../../../minxins";
  import {adTypeRouteMixin, currencySymbolMixin} from "../../../common/mixin";
  import {getAdsAsinPerformanceTargetingType} from "../../../../../../api/ad";
  import {isMeaningful} from "../../../../../../utils/common";
  import {convertToDate} from "../../../../../../utils/date.util";
  import {defaultShow} from "../../../../../../filters";

  export default {
    name: "app-asin-target-analysis",
    mixins: [queryMixin, adTypeRouteMixin, currencySymbolMixin],
    props: {
      marketId: {
        required: true,
      },
      currencySymbol: {
        required: true,
      },
      item: {
        required: true
      },
      queryDate: {
        required: true
      }
    },
    created() {
      this.filter.date = this.queryDate;
    },
    data() {
      return {
        tableData: [],
        summaryData: [],
        columns: [
          {id: 'date', header: '日期', field: 'dateRange', width: '160px', defaultShow: ''},
          {...adFields.campaignTargetType, field: 'slot:campaignTargetType', width: '120px'},
          {...adFields.impressions, sortable: false},
          {...adFields.clicks, sortable: false},
          {...adFields.ctr, sortable: false},
          {...adFields.cost, sortable: false},
          {...adFields.cpc, sortable: false},
          {...adFields.orders, sortable: false},
          {...adFields.cvr, sortable: false},
          {...adFields.cpa, sortable: false},
          {...adFields.sales, sortable: false},
          {...adFields.acos, sortable: false},
        ],
        dateTypeOptions: [
          {id: 'week', text: '周'},
          {id: 'month', text: '月'},
          {id: 'total', text: '汇总'},
        ],
        filter: {
          dateType: 'week',
          date: null
        }
      }
    },
    watch: {
      'filter.dateType'(dateType) {
        this.columns = [
          dateType !== 'total' ? {id: 'date', header: '日期', field: 'dateRange', width: '160px', defaultShow: ''} : null,
          {...adFields.campaignTargetType, field: 'slot:campaignTargetType', width: '120px'},
          {...adFields.impressions, sortable: false},
          {...adFields.clicks, sortable: false},
          {...adFields.ctr, sortable: false},
          {...adFields.cost, sortable: false},
          {...adFields.cpc, sortable: false},
          {...adFields.orders, sortable: false},
          {...adFields.cvr, sortable: false},
          {...adFields.cpa, sortable: false},
          {...adFields.sales, sortable: false},
          {...adFields.acos, sortable: false},
          
        ].filter(e => isMeaningful(e));
      }
    },
    methods: {
      $gjQuery() {
        // 构造查询参数
        const params = {
          marketId: this.marketId,
          // status: this.filter.state,
          msku: this.item.msku,
          dateType: this.filter.dateType,
          startDate: convertToDate(this.filter.date[0]),
          endDate: convertToDate(this.filter.date[1]),
        };
        // 查询
        this.loading = true;
        getAdsAsinPerformanceTargetingType(params)
          .then((data) => {
            if (isMeaningful(data)) {
              const tableData = data.resultList.reduce((e1, e2) => {
                if (e2.length > 0) {
                  e2[0].$gjParentDataType = true;
                  e2[0].$gjDataItemsLength = e2.length;
                }
                return e1.concat(e2);
              }, []);
              // tableData.push(data.total);
              this.tableData = this.currencySymbolMixin(tableData, this.currencySymbol);
              this.summaryData = data.total;
            } else {
              this.tableData = [];
            }
          })
          .complete(() => {
            this.loading = false;
          });
      },
      spanMethod({ row, column, rowIndex, columnIndex }) {
        if (this.filter.dateType !== 'total' && row.targetingType !== 4 && columnIndex === 0) {
          if (row.$gjParentDataType) {
            return {
              rowspan: row.$gjDataItemsLength,
              colspan: 1
            };
          } else {
            return {
              rowspan: 0,
              colspan: 0
            }
          }
        }
      },
      summaryMethod() {
        if (this.summaryData) {
          return [
            this.filter.dateType !== 'total' ? '' : null,
            '总计',
            this.summaryData.impressions,
            this.summaryData.clicks,
            defaultShow(this.summaryData.ctr, '', '%'),
            defaultShow(this.summaryData.cost, this.currencySymbol, ''),
            defaultShow(this.summaryData.cpc, this.currencySymbol, ''),
            this.summaryData.adsOrders,
            this.summaryData.adsSales,
            defaultShow(this.summaryData.acos, '', '%', ''),
            defaultShow(this.summaryData.cvr, '', '%', ''),
            defaultShow(this.summaryData.cpa, this.currencySymbol, '', ''),
          ].filter(e => e !== null)
        } else {
          return [];
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
 /deep/ .gj-table .gj-help--icon .gj-icon{
   color: #999999;
 }
</style>


